<style lang="scss" scoped>
.box-card {
  &_title {
    font-size: 16px;
    color: #666;
  }
  &_body {
    display: flex;
    &_item {
      padding: 20px 15% 0 0;
      display: flex;
      flex-direction: column;
      .num {
        margin-bottom: 6px;
        color: #999999;
        b {
          font-weight: 500;
          font-size: 30px;
          color: #333333;
          padding-right: 10px;
        }
      }
      .title {
        font-size: 14px;
        color: #666;
      }
    }
  }
  .el-divider--vertical {
    height: 10em;
  }
  .line2 {
    margin-top: 22px;
    // .split1 {
    //   margin: 0 15px;
    //   line-height: 33px;
    // }
    // .split2 {
    //   margin: 0 15px;
    //   line-height: 33px;
    // }
  }
}
</style>
<template>
  <div>
    <SpCardContent>
      <el-row>
        <el-col :span="8">
          <div>
            <div
              slot="header"
              class="clearfix"
            >
              <span class="box-card_title">今日实时</span>
            </div>
            <div class="box-card_body">
              <div class="box-card_body_item">
                <div class="num">
                  <b>{{ todayData.new_user }}</b>人
                </div>
                <h5 class="title">
                  新增客户数
                </h5>
              </div>
              <div class="box-card_body_item">
                <div class="num">
                  <b>{{ todayData.bind_user }}</b>人
                </div>
                <h5 class="title">
                  新增绑定客户数
                </h5>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="1">
          <el-divider direction="vertical" />
        </el-col>
        <el-col :span="15">
          <div>
            <div
              slot="header"
              class="clearfix"
            >
              <span class="box-card_title">当前实时总概况</span>
            </div>
            <div class="box-card_body">
              <div class="box-card_body_item">
                <div class="num">
                  <b>{{ totalData.new_user }}</b>人
                </div>
                <h5 class="title">
                  总客户数
                </h5>
              </div>
              <div class="box-card_body_item">
                <div class="num">
                  <b>{{ totalData.bind_user }}</b>人
                </div>
                <h5 class="title">
                  总绑定客户数
                </h5>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </SpCardContent>

    <SpCardContent>
      <div>
        <el-row>
          <el-col :span="10">
            客户增长趋势
            <el-radio-group
              v-model="modeValue"
              @change="changeModel"
            >
              <el-radio-button
                v-for="item in modes"
                :key="item.key"
                :label="item.key"
              >
                {{ item.value }}
              </el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="8">
            <template v-if="isShowDate">
              <el-date-picker
                v-model="plotValue"
                :style="{ width: '360px', marginRight: '20px' }"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="(value) => dateChange(value, 'plot')"
              />
            </template>
          </el-col>
        </el-row>
      </div>
      <div
        id="line-container"
        class="line2"
      />
    </SpCardContent>

    <SpCardContent>
      <SpFinder
        id="1"
        ref="finder"
        title="招新统计"
        :no-selection="true"
        :url="{
          data: requestUrl
        }"
        :show-tool-bar="false"
        :columns="columns"
        :actions="actions"
        :search="search"
        :hooks="{
          beforeSearch: beforeSearch
        }"
        @reset="onFinderReset"
      >
        <template slot="dateSearch">
          <el-date-picker
            v-model="dateValue"
            :style="{ width: '360px', marginRight: '20px' }"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="(value) => dateChange(value, 'list')"
          />
        </template>
      </SpFinder>
    </SpCardContent>
  </div>
</template>

<script>
import { Line } from '@antv/g2plot'
import { setTimeout } from 'timers'
export default {
  name: 'CustomerBox',
  components: {},
  data () {
    //'近7日', '近30天', '自定义'
    const modes = [
      {
        key: 2,
        value: '近7日'
      },
      {
        key: 3,
        value: '近30天'
      },
      {
        key: 0,
        value: '自定义'
      }
    ]
    const columns = [
      {
        name: '时间', // 表头
        key: 'statistic_date' // 匹配data key
      },
      {
        name: '新增客户数', // 表头
        key: 'total_newuser_num' // 匹配data key
      },
      {
        name: '绑定客户数', // 表头
        key: 'total_binduser_num' // 匹配data key
      }
    ]
    const search = [{ key: 'dateSearch', name: '', slot: 'dateSearch' }]
    return {
      requestUrl: process.env.VUE_APP_BASE_API + '/members/every-day-count?date_order_by=desc',
      columns,
      actions: [],
      search,
      modes,
      isShowDate: false,
      loading: true,
      dateValue: [], //自定义日期
      plotValue: [],
      modeValue: 2,
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() >= Date.now() - 8.64e7
        }
      },
      params: {},
      currentFilter: {
        dateRange: 2, //时间段 2:一周内 3:近一个月
        date_order_by: 'asc'
      },
      total_count: 0, //总数据量
      list: [],
      todayData: {},
      totalData: {},
      line: null,
      lineData: []
    }
  },
  computed: {},
  async created () {
    this.getRealTimeCount()
    await this.getEveryDayCount()
  },
  async mounted () {},
  methods: {
    beforeSearch (params) {
      params['start_date'] = this.params.start_date
      params['end_date'] = this.params.end_date
      return params
    },
    onFinderReset () {
      this.dateValue = []
      this.params = {}
    },
    changeModel (value) {
      const isMode = this.modeValue
      this.currentFilter = {
        ...this.currentFilter,
        dateRange: isMode
      }
      if (isMode === 0) return (this.isShowDate = true)
      ;(this.currentFilter.end_date = ''), (this.currentFilter.start_date = '')
      this.getEveryDayCount()
      this.isShowDate = false
    },
    dateChange (val, type) {
      const start_date = val ? val[0] : ''
      const end_date = val ? val[1] : ''
      if (type === 'list') {
        this.params = {
          ...this.params,
          start_date,
          end_date
        }
      } else {
        this.currentFilter = {
          ...this.currentFilter,
          start_date,
          end_date
        }
        this.getEveryDayCount()
      }
    },
    async getEveryDayCount () {
      this.$api.performance.getEveryDayCount(this.currentFilter).then((res) => {
        const { list } = res
        // console.log('list', list)
        const newUser = list.map((item, idx) => ({
          Date: item.statistic_date,
          value: Number(item.total_newuser_num),
          category: '新增客户'
        }))
        const bindUser = list.map((item, idx) => ({
          Date: item.statistic_date,
          value: Number(item.total_binduser_num),
          category: '绑定客户'
        }))
        const datas = newUser.concat(bindUser)
        this.line ? this.line.changeData(datas) : this.drawLine(datas)
      })
    },
    drawLine (data = []) {
      // console.log('data', data)
      this.line = new Line('line-container', {
        data: data,
        padding: 'auto',
        xField: 'Date',
        yField: 'value',
        seriesField: 'category'
      })
      this.line.render()
    },
    async getRealTimeCount () {
      const { today, total } = await this.$api.performance.getRealTimeCount()
      this.todayData = today
      this.totalData = total
    }
  }
}
</script>
